import { getCompanyFunds, selectFundAsDefault } from 'lib/api/funds';
import { CompanyFund } from 'lib/api/funds/types';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import PageHeader, { ActionButton } from 'lib/designSystem/PageHeader';
import EnhancedTable, { Header } from 'lib/designSystem/Table';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import EditFund from './components/EditFund';
import NewFund from './components/NewFund';

const headers: Header[] = [
  { key: 'name', label: 'Nombre' },
  { key: 'cost', label: 'Costo' },
  { key: 'amount', label: 'Monto', type: 'money' },
  { key: 'default', label: 'Default', type: 'vission' },
];

const Funds: React.FC = () => {
  const dispatch = useDispatch();
  const { data: funds, isPending } = getCompanyFunds(dispatch);
  const { mutate: selectFund } = selectFundAsDefault(dispatch);

  const [fund, setFund] = useState<CompanyFund | undefined>();
  const [openNewFund, setOpenNewFund] = useState(false);
  const [openEditFund, setOpenEditFund] = useState(false);

  const handleOpenEditModal = (id: string) => {
    const fund = funds?.find((f) => f.id === id);
    if (!fund) return;
    setFund(fund);
    setOpenEditFund(true);
  };

  const actionButtons: ActionButton[] = [
    {
      onClick: () => setOpenNewFund(true),
      label: 'Agregar',
      color: 'primary',
    },
  ];

  const actions = [
    {
      action: (id: string) => selectFund(id),
      actionLabel: 'Seleccionar como principal',
    },
  ];

  if (isPending) return <CenteredCircularProgress type="dialog" />;

  return (
    <>
      <PageHeader.WithTitleAndActions
        iconType="dashboard"
        title="Fondos"
        subtitle="Acá encontrarás todos tus fondos"
        actionButtons={actionButtons}
      />
      <EnhancedTable
        dataHeaders={headers}
        data={funds ?? []}
        rowsPerPageDefault={50}
        showActions
        actions={actions}
        handleClickRow={handleOpenEditModal}
      />
      <NewFund open={openNewFund} setOpen={setOpenNewFund} />
      <EditFund open={openEditFund} setOpen={setOpenEditFund} fund={fund} />
    </>
  );
};

export default Funds;
